import { useCallback, useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { Card, CardHeader } from 'Components/_theme'
import { ShippingAddressFormSchema } from 'Components/ShippingAddressForm/ShippingAddressForm.types'

import { iconExchangeDevice } from 'Icons/iconExchangeDevice'

import { ReplaceBrokenDeviceShippingForm } from './components/ReplaceBrokenDeviceShippingForm/ReplaceBrokenDeviceShippingForm'
import { ReplaceBrokenDeviceSummary } from './components/ReplaceBrokenDeviceSummary/ReplaceBrokenDeviceSummary'
import {
  ReplaceBrokenDeviceModalProps,
  ReplaceBrokenDeviceModalStepsEnum,
  ReplaceBrokenDeviceModalStepsMap,
} from './ReplaceBrokenDeviceModal.types'

export const ReplaceBrokenDeviceModal = (
  props: ReplaceBrokenDeviceModalProps,
) => {
  const { handleSubmit, onClose, rental } = props

  const [shippingFormData, setShippingFormData] =
    useState<ShippingAddressFormSchema | null>()
  const [currentStep, setCurrentStep] =
    useState<`${ReplaceBrokenDeviceModalStepsEnum}`>(
      ReplaceBrokenDeviceModalStepsEnum.SHIPPING,
    )

  const handleSetCurrentStep = useCallback(
    (
      step: `${ReplaceBrokenDeviceModalStepsEnum}`,
      shippingData?: ShippingAddressFormSchema,
    ) => {
      if (shippingData) {
        setShippingFormData({ ...shippingData })
      }

      setCurrentStep(step)
    },
    [],
  )

  const stepsMap = useMemo(
    (): ReplaceBrokenDeviceModalStepsMap => ({
      [ReplaceBrokenDeviceModalStepsEnum.SHIPPING]: {
        component: ReplaceBrokenDeviceShippingForm,
        props: {
          onCancel: onClose,
          onSetCurrentStep: handleSetCurrentStep,
          rental,
          shippingFormData,
        },
      },
      [ReplaceBrokenDeviceModalStepsEnum.SUMMARY]: {
        component: ReplaceBrokenDeviceSummary,
        props: {
          onSetCurrentStep: handleSetCurrentStep,
          onSubmit: handleSubmit,
          rental,
          shippingFormData,
        },
      },
    }),
    [handleSetCurrentStep, handleSubmit, onClose, rental, shippingFormData],
  )

  const renderStep = useMemo(() => {
    const { component: Component, props } = stepsMap[currentStep]

    return { component: <Component {...props} /> }
  }, [stepsMap, currentStep])

  return (
    <Card>
      <CardHeader icon={iconExchangeDevice}>
        <FormattedMessage id="Replace_broken_device" />
      </CardHeader>

      {renderStep.component}
    </Card>
  )
}
